let lastId = 0;
export function uniqueIdGenerator(prefix:string)
{
  lastId++;
  return `${prefix}_${lastId}`;
}
